// extracted by mini-css-extract-plugin
export var changeIcon = "_4d-4";
export var container = "_4d-0";
export var divider = "_4d-7";
export var externalLinkIcon = "_4d-1";
export var green = "_4d-5";
export var helpCircleIcon = "_4d-3";
export var iconButton = "_4d-2";
export var red = "_4d-6";